<template>
  <div v-if="messages.length" class="drupal-messages">
    <div v-for="(message, i) in messages" :key="i" class="message" :class="classes[message.type]"
      @click="removeMessage(i)">
      <div v-html="message.message" />
      <SpriteSymbol name="close" class="size-6" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { DrupalMessageType } from '~/composables/useDrupalMessages'

const { messages, removeMessage } = useDrupalMessages()

const classes: Record<DrupalMessageType, string> = {
  error: 'message--error',
  warning: 'message--warning',
  status: 'message--success',
}
</script>

<style lang="postcss">
.drupal-messages {
  color: #fff;
  width: 100%;
  z-index: 9999999;
  left: 0;
  bottom: 0;
  position: fixed;

  .message {
    font-weight: 600;
    padding: 24px;
    border-radius: .25rem;
    justify-content: space-between;
    align-items: center;
    display: flex;

    &.message--error {
      color: #570c10;
      background-color: rgb(248 210 212 / 1);
    }

    &.message--warning {
      color: #640;
      background-color: rgb(255 238 204 / 1);
    }

    &.message--success {
      color: #3a4a18;
      background-color: rgb(233 241 216 / 1);
    }

    svg {
      fill: currentColor;
      height: 24px;
      width: 24px;
      display: block;
      vertical-align: middle;
    }
  }
}
</style>
